import { IconCircleFilled, IconAlertTriangle } from '@tabler/icons-react';

const MessengerStatus = ({ account }) => {
  if (!account) return null;

  let color = '#10b981'; // verde
  let label = 'Ativo';

  if (account.token_validation_error) {
    color = '#dc2626';
    label = 'Token inválido';
  } else if (account.bot_paused) {
    color = '#f59e0b';
    label = 'IA pausada (operador humano ativo)';
  } else if (!account.is_active) {
    color = '#94a3b8';
    label = 'Desconectado';
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.25rem',
        fontSize: 12,
        color: '#64748b',
        marginTop: 4,
      }}
    >
      {account.token_validation_error ? (
        <IconAlertTriangle size={12} color={color} />
      ) : (
        <IconCircleFilled size={10} color={color} />
      )}
      <span>{label}</span>
      {account.token_validation_error && (
        <span style={{ marginLeft: 4, color: '#dc2626' }}>
          — {account.token_validation_error}
        </span>
      )}
    </div>
  );
};

export default MessengerStatus;
